import React from "react";
import MasterLayout from "../../../masterLayout/MasterLayout";
import Breadcrumb from "../../../components/Breadcrumb";
import ManageFollowUpLayer from "../../../components/crm/ManageFollowUpLayer";

const FollowUp = () => {
  return (
    <>
      {/* MasterLayout */}
      <MasterLayout>
        {/* Breadcrumb */}
        <Breadcrumb title='Manage Enquiry' />
        {/* BlankPageLayer */}
        <ManageFollowUpLayer />
      </MasterLayout>
    </>
  );
};

export default FollowUp;